import { Autoplay, Keyboard, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import Proj001Cover from "../../assets/projects/001/1-cover.png";
import Proj002Cover from "../../assets/projects/002/2-cover.png";
import Proj004Cover from "../../assets/projects/004/4-cover.png";
import Proj005Cover from "../../assets/projects/005/5-cover.png";
import Proj006Cover from "../../assets/projects/006/6-cover.png";
import Proj007Cover from "../../assets/projects/007/7-cover.png";
import Proj008Cover from "../../assets/projects/008/8-cover.png";
import Proj009Cover from "../../assets/projects/009/9-cover.png";
import Proj010Cover from "../../assets/projects/010/010-cover.png";
import Proj011Cover from "../../assets/projects/011/011-cover.png";
import Proj012Cover from "../../assets/projects/012/012-cover.png";
import Proj001Presentation from "../../assets/projects/001/1-presentation.pdf";
import Proj002Presentation from "../../assets/projects/002/2-presentation.pdf";
import Proj004Presentation from "../../assets/projects/004/4-presentation.pdf";
import Proj005Presentation from "../../assets/projects/005/5-presentation.png";
import Proj006Presentation from "../../assets/projects/006/6-presentation.pdf";
import Proj008Presentation from "../../assets/projects/008/8-presentation.pdf";
import Proj009Presentation from "../../assets/projects/009/9-presentation.pdf";
import Proj010Presentation from "../../assets/projects/010/010-presentation.pdf";
import Proj011Presentation from "../../assets/projects/011/011-presentation.pdf";
import Proj012Presentation from "../../assets/projects/012/012-presentation.pdf";
import "swiper/css";
import "swiper/css/navigation";

const projects = [
  { name: "Tasky", img: Proj010Cover, presentation: Proj010Presentation },
  {
    name: "Sounder",
    img: Proj008Cover,
    presentation: Proj008Presentation,
    objectPosition: "top",
  },
  {
    name: "WeStream",
    img: Proj005Cover,
    presentation: Proj005Presentation,
    figma:
      "https://www.figma.com/proto/JRfqEgIhu1MU2NOMpC9c25/WeStream?type=design&node-id=104-52&t=B8tZDyoN0P8Jv6Zs-1&scaling=min-zoom&page-id=0%3A1&mode=design",
  },
  {
    name: "Interreg",
    img: Proj007Cover,
    figma:
      "https://www.figma.com/file/Pdhqk4Q4zZKI4XLgCQtBxv/Interreg?type=design&node-id=0%3A1&mode=design&t=KXsfeoJFt8og1CtF-1",
  },
  {
    name: "Arpal Puglia",
    img: Proj006Cover,
    presentation: Proj006Presentation,
  },
  {
    name: "Expe Branding",
    img: Proj011Cover,
    presentation: Proj011Presentation,
  },
  {
    name: "Expe Mobile App",
    img: Proj012Cover,
    presentation: Proj012Presentation,
  },
  {
    name: "Wolfox",
    img: Proj004Cover,
    presentation: Proj004Presentation,
    figma:
      "https://www.figma.com/file/q7CPRQW8j0AReuErrfH3Rd/Wolfox?type=design&node-id=0-1&mode=design&t=ovLCyTIM7lWLDxV6-0",
  },
  {
    name: "Sounder Email",
    img: Proj009Cover,
    presentation: Proj009Presentation,
  },
  {
    name: "Crystalline Rose",
    img: Proj001Cover,
    presentation: Proj001Presentation,
  },
  { name: "Marco Indigo", img: Proj002Cover, presentation: Proj002Presentation },
];

export default function ProjectsList() {
  return (
    <Swiper
      spaceBetween={50}
      slidesPerView={1}
      autoplay={{ delay: 4000, disableOnInteraction: false }}
      loop
      navigation
      keyboard
      pagination
      onSwiper={(swiper) => console.log(swiper)}
      modules={[Autoplay, Navigation, Pagination, Keyboard]}
    >
      {projects.map((proj) => (
        <SwiperSlide key={proj.name}>
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <div style={{ width: 1280, maxWidth: "100%" }}>
              <a
                href={proj.presentation || proj.img}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={proj.img}
                  alt={proj.name}
                  style={{
                    width: "100%",
                    height: 720,
                    maxHeight: "50vh",
                    objectFit: "cover",
                    borderRadius: 20,
                    overflow: "hidden",
                    objectPosition: proj.objectPosition || "center",
                  }}
                />
              </a>
              {(!!proj.presentation || !!proj.figma) && (
                <div
                  style={{
                    marginTop: 20,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 20,
                  }}
                >
                  {!!proj.presentation?.endsWith(".pdf") && (
                    <a
                      href={proj.presentation}
                      target="_blank"
                      style={{
                        padding: "1rem 2rem",
                        backgroundColor: "var(--pink)",
                        borderRadius: 9999,
                        color: "#fff",
                        cursor: "pointer",
                      }}
                      rel="noopener noreferrer"
                    >
                      <b>PDF</b>
                    </a>
                  )}
                  {!!proj.figma && (
                    <a
                      href={proj.figma}
                      target="_blank"
                      style={{
                        padding: "1rem 2rem",
                        backgroundColor: "var(--pink)",
                        borderRadius: 9999,
                        color: "#fff",
                        cursor: "pointer",
                      }}
                      rel="noopener noreferrer"
                    >
                      <b>Figma</b>
                    </a>
                  )}
                </div>
              )}
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
